var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJeonbuk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.46 0H0V25.46H25.46V0Z",
    fill: "#008CCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L6.36314 6.36686L12.73 0H0Z",
    fill: "#008CCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V12.73L6.36314 6.36686L0 0Z",
    fill: "#0095D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.73 12.73L6.36686 6.36316L0 12.73H12.73Z",
    fill: "#008CCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7303 12.73V0L6.36719 6.36314L12.7303 12.73Z",
    fill: "#007AC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7305 0V12.73L19.0936 6.36686L12.7305 0Z",
    fill: "#0067B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4605 12.73L19.0973 6.36316L12.7305 12.73H25.4605Z",
    fill: "#004294"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.73L6.36314 19.0968L12.73 12.73H0Z",
    fill: "#007AC6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.73V25.46L6.36314 19.0968L0 12.73Z",
    fill: "#0067B6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.73 25.46L6.36686 19.0931L0 25.46H12.73Z",
    fill: "#005BAC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7303 25.46V12.73L6.36719 19.0931L12.7303 25.46Z",
    fill: "#004898"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7305 12.73L19.0936 19.0968L25.4605 12.73H12.7305Z",
    fill: "#08287F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7305 12.73V25.46L19.0936 19.0968L12.7305 12.73Z",
    fill: "#004294"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4605 25.46L19.0973 19.0931L12.7305 25.46H25.4605Z",
    fill: "#08287F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4598 25.46V12.73L19.0967 19.0931L25.4598 25.46Z",
    fill: "#08287F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7305 0L19.0936 6.36686L25.4605 0H12.7305Z",
    fill: "#005BAC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4598 12.73V0L19.0967 6.36314L25.4598 12.73Z",
    fill: "#004898"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4597 15.9134L17.3077 8.15198L4.93848 20.551L9.44958 25.0621L17.3077 17.3267L25.4597 25.434V15.9134Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeonbuk);
export default __webpack_public_path__ + "static/media/jeonbuk.e94bc6194d3fbe4d1a08f376b38f3940.svg";
export { ForwardRef as ReactComponent };